import { createSelector } from 'reselect';

const PasswordReset = 'passwordReset';

const selectPrivilegeCheckLoading = (state) =>
  state.get(PasswordReset).get('privilegeCheckLoading');
const isCheckingPrivilege = createSelector(selectPrivilegeCheckLoading, (data) => data);

const selectHasPasswordChangePrivilege = (state) =>
  state.get(PasswordReset).get('hasPasswordChangePrivilege');
const isAllowedToChangePassword = createSelector(selectHasPasswordChangePrivilege, (data) => data);

const selectIsLoading = (state) => state.get(PasswordReset).get('isLoading');
const getPasswordResetLoadingStatus = createSelector(selectIsLoading, (data) => data);

const selectActionResponse = (state) => state.get(PasswordReset).get('actionResponse');
const getPasswordResetActionResponse = createSelector(selectActionResponse, (data) => data);

export {
  isCheckingPrivilege,
  isAllowedToChangePassword,
  getPasswordResetLoadingStatus,
  getPasswordResetActionResponse,
};
